export default {
  pageTitle: '特殊产品类型',
  specialCode: '特殊产品编码',
  specialType: '特殊产品类型',
  exceptionType: '异常类型',
  lastUpdatedBy: '最后更新用户',
  lastUpdateTime: '最后更新时间',
  disableConfirmSimple: '是否确认禁用该特殊产品编号？',
  disableConfirmLinkedPrefix: '以下产品与该特殊类型关联。禁用后，这些产品将不再被视为特殊产品。',
  mandatoryFields: '请补充完整必填信息再进行提交。',
  errorcode_6001: '此特殊产品编码已存在，请直接在页面搜索后再进行编辑及更新。',
  errorcode_6004: '此特殊产品编码已存在，请输入新编码。',
  selectData: '请选择要禁用的数据。'
}
